export default __webpack_public_path__ + "static/autoguard-logo-81b39c72440e1e275bb5949b94d4a477.png";